import React, { useEffect, useState } from 'react';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import constraints from '../constraints';

function createRandomString(length) {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';
  for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

export default function KakaoProfilePayment() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const phoneNumber = params.get('phone_number');

    loadTossPayments(constraints.config.TOSS_CLIENT_KEY).then(tossPayments => {
      tossPayments.requestPayment('카드', { // 결제 수단 파라미터
        // 결제 정보 파라미터
        amount: 2500,
        orderId: `${phoneNumber}-kakao-profile-${createRandomString(6)}`,
        orderName: `카카오톡 프로필조회`,
        // customerName: '박토스',
        successUrl: constraints.config.TOSS_PAYMENT_DIRECT_PURCHASE_SUCCESS_CALLBACK_URL,
        failUrl: constraints.config.TOSS_PAYMENT_DIRECT_PURCHASE_FAIL_CALLBACK_URL,
      });
    });
  }, []);

  return (
    <div className="w-full h-full flex flex-col justify-center items-center">
    </div>
  );
}